import { principles } from "@/mocks/chaqua";

const STATS = [
  { num: "24h", label: "全天滚动更新" },
  { num: "6+", label: "内容栏目" },
  { num: "90%", label: "来自公开平台" },
  { num: "100万+", label: "日均围观人次" },
];

export default function About() {
  return (
    <section id="about" className="scroll-mt-20 bg-cream-50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid gap-8 lg:grid-cols-[1fr_1.1fr] lg:items-start">
          <div>
            <span className="text-xs font-bold uppercase tracking-widest text-coral-500">About Us</span>
            <h2 className="mt-2 text-2xl font-black text-stone-900 md:text-3xl">吃瓜指南，一个正经吃瓜的站点</h2>
            <p className="mt-4 text-sm leading-relaxed text-stone-600 md:text-base">
              吃瓜在线诞生于一个朴素的想法：每天全网有那么多<span className="font-semibold text-stone-800">今日大瓜、今日热议与今日新鲜事</span>，
              但消息散落在不同平台，追起来又累又乱。我们希望做一个"看得全、跟得快、说得清"的聚合入口，帮你把今天的瓜一次吃明白。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-stone-600 md:text-base">
              我们不生产谣言，只做信息的搬运与梳理。对每一则内容，我们优先呈现讨论热度与公开来源，对尚无定论的传闻会明确标注，让"吃瓜"这件事少一点误伤，多一点清醒。
            </p>

            <dl className="mt-7 grid grid-cols-2 gap-3 sm:grid-cols-4">
              {STATS.map((s) => (
                <div key={s.label} className="rounded-2xl border border-cream-200 bg-white p-4 text-center">
                  <dt className="sr-only">{s.label}</dt>
                  <dd className="font-display-num text-2xl font-black text-coral-500">{s.num}</dd>
                  <dd className="mt-1 text-xs text-stone-500">{s.label}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div>
            <h3 className="text-base font-bold text-stone-900">我们的内容原则</h3>
            <div className="mt-4 grid gap-3 sm:grid-cols-2">
              {principles.map((p) => (
                <div
                  key={p.title}
                  className="group rounded-2xl border border-cream-200 bg-white p-4 transition hover:border-leaf-200 hover:bg-leaf-50/50"
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-leaf-100 text-lg text-leaf-600">
                    <i className={p.icon} aria-hidden="true"></i>
                  </span>
                  <h4 className="mt-3 text-sm font-bold text-stone-900">{p.title}</h4>
                  <p className="mt-1.5 text-sm leading-relaxed text-stone-500">{p.desc}</p>
                </div>
              ))}
            </div>
            <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2 rounded-2xl border border-coral-100 bg-coral-50/70 px-5 py-4 text-sm text-stone-700">
              <span className="flex items-center gap-2 font-semibold text-stone-800 whitespace-nowrap">
                <i className="ri-chat-smile-3-line text-coral-500" aria-hidden="true"></i>用户口碑
              </span>
              <p className="text-sm text-stone-600">
                “追热点终于不用在三个 App 之间反复横跳了，这里一条刷完今天都在聊什么。”—— 来自一位每天蹲热榜的网友
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}